import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, previewImages } from '../data/fono';
export function PreviewCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(previewImages.length - 1, i));
    const slide = track.children[clamped] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth;
      if (width === 0) return;
      setIndex(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-teal px-3 py-5 sm:py-7" data-id="element-120" data-mp="3alvs4ux0cojp">
      <div className="mx-auto max-w-3xl" data-id="element-121" data-mp="3amf2nqkbwanp">
        <p className="text-center text-[9px] font-extrabold uppercase tracking-[0.2em] text-mustard sm:text-xs" data-id="element-122" data-mp="3fli6x8shicum">
          Preview the material
        </p>
        <h2 className="mt-1 text-center text-xl leading-tight text-white sm:text-3xl" data-id="element-123" data-mp="3kd9q2y9b9gaq">
          Take a Look Inside FONO KIDS PRO™
        </h2>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[13px] font-medium leading-snug text-mint" data-id="element-124" data-mp="3tcdbw9zv49sx">
          Explore the printable cards, visual activities, games, picture scenes, sorting
          resources, sequences and ready-to-use materials included throughout the complete
          system.
        </p>

        <div className="relative mt-3" data-id="element-125" data-mp="23ygpn423nxds">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" aria-label="Preview of pages inside FONO KIDS PRO™" data-id="element-126" data-mp="23zrwxdur7n9n">
            {previewImages.map(image => <li key={image.src} className="w-full shrink-0 snap-center" data-id="element-127" data-mp="1vy2f6wm97cr2">
                <a href={OFFER_ANCHOR} className="block" data-id="element-128" data-mp="2aut60hhv3g52">
                  <img src={image.src} alt={image.alt} loading="lazy" className="mx-auto w-full rounded-lg border-2 border-mint bg-white shadow-2xl" data-id="element-129" data-mp="2as6xofn5cwls" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-teal shadow-lg transition-colors duration-150 hover:bg-coral hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-130" data-mp="2eu0toamedcfm">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="3h97qopcs6viz" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === previewImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-teal shadow-lg transition-colors duration-150 hover:bg-coral hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-132" data-mp="3m7hm912f3y54">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-133" data-mp="33a84rpgnkuqi" />
          </button>
        </div>

        <div className="mt-2.5 flex items-center justify-center gap-2" data-id="element-134" data-mp="2tik4r06165df">
          {previewImages.map((image, i) => <button key={image.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1} of ${previewImages.length}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-soft ${i === index ? 'w-6 bg-mustard' : 'w-2 bg-white/40 hover:bg-white/70'}`} data-id="element-135" data-mp="2fi9d3uwwcmr7" data-mpi={i} />)}
        </div>

        <CTAButton className="mx-auto mt-3 max-w-md" data-id="element-136" data-mp="393wwofbs37zd">
          🗣️ YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
      </div>
    </section>;
}